/**
 * Not Found Redirect Component
 *
 * Intelligently redirects users from unknown routes based on authentication status.
 * - Authenticated users → /dashboard
 * - Unauthenticated users → /login
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/state/auth-context';

/**
 * Not Found Redirect Component
 *
 * Redirects to appropriate route based on authentication status.
 * Prevents redirect loops by checking auth state first.
 *
 * @returns Redirect element
 */
export function NotFoundRedirect() {
  const { isAuthenticated, state } = useAuth();

  // If still loading auth state, show a brief loading indicator
  if (state.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" />
        </div>
      </div>
    );
  }

  // Redirect based on authentication status
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />;
}
